import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import useCart from '../hooks/useCart';
import { Fetching } from './Fetching';
import views from '../constants/views';

const styles = {
  buttonDisabled: {
    cursor: 'not-allowed'
  }
};

export const BookButtonContainer = ({
  children,
  disabled,
  navigate,
  onClick,
  overrideOnClick,
  overrideDisabled,
  ...props
}) => {
  let cart = useCart({ onAddToCart: () => navigate(views.SERVICE_LIST) }).cart;
  if (disabled) {
    cart = null;
  }

  if (!overrideOnClick && !cart && !disabled) {
    return <Fetching fetching />;
  }

  let buttonStyle = { ...props.style };
  if ((!overrideOnClick && disabled) || overrideDisabled) {
    buttonStyle = { ...buttonStyle, ...styles.buttonDisabled };
  }

  return (
    <BookButton
      { ...props }
      onClick={ overrideOnClick ? onClick : cart?.addCurrentService }
      disabled={ overrideOnClick ? overrideDisabled : disabled }
      style={ buttonStyle }
    >
      { children }
    </BookButton>
  );
};

BookButtonContainer.propTypes = {
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  overrideOnClick: PropTypes.bool,
  overrideDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  navigate: PropTypes.func.isRequired,
  style: PropTypes.object
};

const BookButton = ({ children, onClick, dataAid, ...props }) => {
  const { Button } = UX2.Element;

  return (
    <Button { ...props } data-aid={ dataAid } onClick={ onClick }>
      { children }
    </Button>
  );
};

BookButton.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  dataAid: PropTypes.string
};

export default BookButtonContainer;
